import React from 'react';
import style from './HorizontalDivider.module.less';

function HorizontalDivider({ className }) {
  return (
    <div>
      <hr className={`${className} ${style.hrElement}`} />
    </div>
  );
}

export default HorizontalDivider;
